export default "__VITE_ASSET__CH3cfUJ5__"